import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { IConfigPage, IPerson } from 'src/app/metadata/interfaces/page/Pages';
import { SkyaccessApp } from 'src/app/services/skyaccessconfig/skyaccess-app.service';




declare const $: any;
 
@Component({ 
  selector: 'app-key-menu',
  templateUrl: './key-menu.component.html',
  styleUrls: ['./key-menu.component.scss']
})
export class KeyMenuComponent implements OnInit, AfterViewInit {
  public ConfigPage : IConfigPage;
  public IsKeyValid : boolean; 
  public Pers : any;
  public IsClicked : boolean = true;
  public AnimatedCls : string = "menu animated infinite pulse";
  

  constructor(private _router : Router, private skyAcceAp : SkyaccessApp ) { 

    
  }  
  
  ngOnInit() { 
    setTimeout(() => {
      
    

    this.IsClicked = false;
    this.ConfigPage = this.skyAcceAp._ConfigPage;
    this.Pers = this.skyAcceAp._Pers;

    var CurentDt = new Date();
    var dt = new Date(Date.parse(this.Pers._ExpDate));

    if(CurentDt.getTime() >= dt.getTime())
      this.IsKeyValid = false;
    else
      this.IsKeyValid = true; 
    
    this.IsKeyValid = true;


    // var ConfigPage = (val : any) : void =>  {  this.ConfigPage = val; } 
    // this.skyAcceAp.GetConfigSettings(ConfigPage); 
    // var Pers = (val : any) : void =>  {   this.Pers = val;  } 
    // this.skyAcceAp.GetPerson(Pers);
    
    $(document).ready(function(ev) {
      var toggle = $('#ss_toggle');
      var menu = $('#ss_menu');
      var rot;
      
      $('#ss_toggle').on('click', function(ev) {
        rot = parseInt($(this).data('rot')) - 180;
        menu.css('transform', 'rotate(' + rot + 'deg)');
        menu.css('webkitTransform', 'rotate(' + rot + 'deg)');
        if ((rot / 180) % 2 == 0) {
          //Moving in
          toggle.parent().addClass('ss_active');
          toggle.addClass('close');
        } else {
          //Moving Out
          toggle.parent().removeClass('ss_active'); 
          toggle.removeClass('close');
        }
        $(this).data('rot', rot);
      });
     
      menu.on('transitionend webkitTransitionEnd oTransitionEnd', function() {
        if ((rot / 180) % 2 == 0) {
          $('#ss_menu div i').addClass('ss_animate');
        } else {
          $('#ss_menu div i').removeClass('ss_animate');
        }
      });
    });
    }, 500);
  
  }

  SetMenuStyle():void{
  
    if(!this.IsKeyValid) return;

    let IframesDoc = document;
    this.ConfigPage?.KeyMenu.forEach(k => {
      
      switch(k.ID)
      {
        case'KmColor': 
          // (IframesDoc.querySelector('#ss_menu > .menu .share .bar') as HTMLElement).style.background = k.Color; 
          // let style = IframesDoc.createElement('style');
          // style.innerHTML = '#ss_menu > .menu .share .bar::before {background:' + k.Color + ' !important;}';
          // IframesDoc.querySelector('head').appendChild(style); 
          // IframesDoc.querySelectorAll('#ss_menu > .ss_sub_menu i').forEach( c => { (c as HTMLElement).style.color = k.Color });

           (IframesDoc.querySelector('.keyIcon') as HTMLElement).style.color =  k.Color; 
            
         break;
  
         case'KmBgColor': 
          (IframesDoc.querySelector('#ss_menu > .menu') as HTMLElement).style.background = k.BgColor; 
          IframesDoc.querySelectorAll('#ss_menu > .ss_sub_menu ').forEach( c => { (c as HTMLElement).style.background = k.BgColor });  
         break;
      }
  
    });


  }


  ngAfterViewInit() {
 
     // $( "#ss_menu" ).draggable();
     

    // function handle_mousedown(e){

    //   ("mouse down...");
    
      
    //   var my_dragging : any = {};
    //   my_dragging.pageX0 = e.pageX;
    //   my_dragging.pageY0 = e.pageY;
    //   my_dragging.elem = this;
    //   my_dragging.offset0 = $(this).offset();
    //   function handle_dragging(e){
    //       var left = my_dragging.offset0.left + (e.pageX - my_dragging.pageX0);
    //       var top = my_dragging.offset0.top + (e.pageY - my_dragging.pageY0);
    //       $(my_dragging.elem)
    //       .offset({top: top, left: left});
    //   }
    //   function handle_mouseup(e){
    //       $('body')
    //       .off('mousemove', handle_dragging)
    //       .off('mouseup', handle_mouseup);
    //   }
    //   $('body')
    //   .on('mouseup', handle_mouseup)
    //   .on('mousemove', handle_dragging);
    // }
    // $('#ss_menu').on("mousedown", handle_mousedown);

    setTimeout( () => { 
      this.SetMenuStyle(); 
    }, 1000);
 
    


  }
   

OnClick() : void { 

  this._router.navigate(['hotel/doors-access']); 
  return;


  this.IsClicked = !this.IsClicked;
  if(this.IsClicked && document.querySelector(".ss_active") != undefined)
  {
      this.AnimatedCls ="menu MnActive"
      this.IsClicked = true;
  }
  else
  {
      this.IsClicked = false;
      this.AnimatedCls ="menu animated infinite pulse MnNormal";

  }
}

  RefreshKey() :void{
   // this._router.navigate(['hotel/welcome']);
    location.reload();
  }

  ShareKey() :void{
    
  }

  DispalyChat() :void{
    this._router.navigate(['hotel/chat']);
  }

  DisplayDoorList() :void{
    this._router.navigate(['hotel/doors-access']);
  }



}
